var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-scale"},[_c('div',{staticClass:"line-scale__thumb",class:("line-scale__thumb--" + _vm.colorThumb),style:({
      width: (_vm.value + "%")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }